module.exports = {
  'en': {
    'HREP83EC': {
      '10': 'Asset Type',
      '20': 'For Date',
      '30': 'Available Time',
      '40': 'Asset No.',
      '50': 'Description',
      '60': 'Status',
      '70': 'Reserved Time',
      '80': 'Reserve by',
      '90': 'Department',
      '100': 'Details Of Asset',
      '110': 'freedom'
    },
    'HREP83EC2': {
      '10': 'Asset No.',
      '20': 'Asset Type',
      '30': 'Request date',
      '40': 'Reserve Date',
      '50': 'From',
      '60': 'To',
      '70': 'From Time',
      '80': 'To Time',
      '90': 'Objective',
      '100': 'Status',
      '110': 'Reserve',
      '120': 'Cancel'
    },
    'HREP83EC3': {
      '10': 'For Asset No.',
      '20': 'Month',
      '30': 'Year',
      '40': 'Details of reservation',
      '50': 'Request Date',
      '60': 'Reserve By',
      '70': 'reservation Period',
      '80': 'Status'
    },
    'HRPM1EEC2': {
      '0': 'Asset Detail',
      '10': 'Asset Code',
      '20': 'Asset name',
      '30': 'Image File',
      '40': 'Acquire  Date',
      '50': 'Description',
      '60': 'Source',
      '70': 'Type of  Asset',
      '80': 'Existing No.',
      '90': 'Unit',
      '100': 'Existing Quantity',
      '110': 'Update by',
      '120': 'Date Update'
    }
  },
  'th': {
    'HREP83EC': {
      '10': 'ประเภททรัพย์สิน',
      '20': 'สำหรับวัน',
      '30': 'ช่วงเวลาที่ว่าง',
      '40': 'รหัสทรัพย์สิน',
      '50': 'รายละเอียด',
      '60': 'สถานะ',
      '70': 'ช่วงเวลาที่จอง',
      '80': 'จองโดย',
      '90': 'หน่วยงาน',
      '100': 'รายละเอียดทรัพย์สิน',
      '110': 'ว่าง'
    },
    'HREP83EC2': {
      '10': 'รหัสทรัพย์สิน',
      '20': 'ประเภททรัพย์สิน',
      '30': 'วันที่บันทึก',
      '40': 'วันที่จอง',
      '50': 'จาก',
      '60': 'ถึง',
      '70': 'เวลาเริ่มต้น',
      '80': 'เวลาสิ้นสุด',
      '90': 'วัตถุประสงค์',
      '100': 'สถานะ',
      '110': 'จอง',
      '120': 'ยกเลิก'
    },
    'HREP83EC3': {
      '10': 'สำหรับทรัพย์สินเลขที่',
      '20': 'เดือน',
      '30': 'ปี',
      '40': 'รายละเอียดการจอง',
      '50': 'วันที่ขอเบิก',
      '60': 'จองโดย',
      '70': 'ช่วงเวลาที่จอง',
      '80': 'สถานะการจอง'
    },
    'HRPM1EEC2': {
      '0': 'รายละเอียดทรัพย์สิน',
      '10': 'รหัสทรัพย์สิน',
      '20': 'ชื่อทรัพย์สิน',
      '30': 'File รูปภาพ',
      '40': 'วันที่ได้มา',
      '50': 'รายละเอียด',
      '60': 'แหล่งที่ได้มา',
      '70': 'ประเภททรัพย์สิน',
      '80': 'จำนวนคงเหลือ',
      '90': 'หน่วยนับ',
      '100': 'จำนวนที่มีอยู่',
      '110': 'แก้ไขโดย',
      '120': 'แก้ไขเมื่อ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres83e.js